"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.detachOperationNodes = exports.getConverterByArtifactType = exports.tapeConvertors = void 0;
const common_1 = require("@finley-technologies/common");
const converter_1 = require("./tapes/assigned-repayment-tape/converter");
const converter_2 = require("./tapes/config-tape/converter");
const converter_3 = require("./tapes/datalake-tape/converter");
const converter_4 = require("./tapes/direct-insert-borrowing-base-report/converter");
const converter_5 = require("./tapes/direct-insert-financial-covenants/converter");
const converter_6 = require("./tapes/direct-insert-portfolio-covenant/converter");
const converter_7 = require("./tapes/direct-insert-portfolio-covenants/converter");
const converter_8 = require("./tapes/fin-statement/converter");
const converter_9 = require("./tapes/forwarded-tape/converter");
const converter_10 = require("./tapes/generated-borrowing-base-report/converter");
const converter_11 = require("./tapes/generated-cash-balance-feed/converter");
const converter_12 = require("./tapes/generated-covenant-loan-tape/converter");
const converter_13 = require("./tapes/generated-financial-data/converter");
const converter_14 = require("./tapes/generated-funding-request/converter");
const converter_15 = require("./tapes/generated-loan-tape/converter");
const converter_16 = require("./tapes/generated-receivable-invoice/converter");
const converter_17 = require("./tapes/generated-receivable-response-tape/converter");
const converter_18 = require("./tapes/generated-repayment-tape/converter");
const converter_19 = require("./tapes/generated-supplemental-tape/converter");
const converter_20 = require("./tapes/intermediate-tape/converter");
const converter_21 = require("./tapes/limited-partners-tape/converter");
const converter_22 = require("./tapes/org-provided-input/converter");
const converter_23 = require("./tapes/org-provided-inputs/converter");
const converter_24 = require("./tapes/raw-cash-balance-feed/converter");
const converter_25 = require("./tapes/raw-loan-tape/converter");
const converter_26 = require("./tapes/raw-receivable-documentation/converter");
const converter_27 = require("./tapes/raw-repayment-tape/converter");
const converter_28 = require("./tapes/raw-supplemental-tape/converter");
const converter_29 = require("./tapes/raw-zip-tape/converter");
const converter_30 = require("./tapes/upload-to-datalake/converter");
const converter_31 = require("./tapes/valley-bank-ingest/converter");
const converter_32 = require("./tapes/valley-bank-sls-commitment/converter");
const converter_33 = require("./tapes/valley-bank-sls-ingest/converter");
const converter_34 = require("./tapes/wait-for-datalake/converter");
const uiNodes_1 = require("./uiNodes");
// Tape Convertors
exports.tapeConvertors = {
    // Raw
    rawLoanTape: converter_25.converter,
    rawCashBalanceFeed: converter_24.converter,
    rawReceivableDocumentation: converter_26.converter,
    rawRepaymentTape: converter_27.converter,
    rawSupplementalTape: converter_28.converter,
    rawZipTape: converter_29.converter,
    // config node
    configTape: converter_2.converter,
    // intermediate/generated
    intermediateTape: converter_20.converter,
    generatedCovenantLoanTape: converter_12.converter,
    generatedLoanTape: converter_15.converter,
    generatedCashBalanceFeed: converter_11.converter,
    generatedRepaymentTape: converter_18.converter,
    assignedRepaymentTape: converter_1.converter,
    generatedReceivableResponseTape: converter_17.converter,
    generatedBorrowingBaseReport: converter_10.converter,
    directInsertBorrowingBaseReport: converter_4.converter,
    directInsertPortfolioCovenant: converter_6.converter,
    directInsertPortfolioCovenants: converter_7.converter,
    directInsertFinancialCovenants: converter_5.converter,
    valleyBankIngestTape: converter_31.converter,
    valleyBankSlsIngestTape: converter_33.converter,
    valleyBankSlsCommitmentTape: converter_32.converter,
    // data lake
    dataLakeTape: converter_3.converter,
    uploadToDatalake: converter_30.converter,
    waitForDataLakeTable: converter_34.converter,
    limitedPartnersTape: converter_21.converter,
    // Final
    forwardedTape: converter_9.converter,
    generatedFundingRequest: converter_14.converter,
    generatedReceivableInvoice: converter_16.converter,
    generatedSupplementalTape: converter_19.converter,
    generatedFinancialData: converter_13.converter,
    finStatement: converter_8.converter,
    orgProvidedInput: converter_22.converter,
    orgProvidedInputs: converter_23.converter,
};
const tapeConvertorArray = Object.values(exports.tapeConvertors);
const getConverterByArtifactType = (artifactType) => {
    const converter = tapeConvertorArray.find((con) => con.artifactType === artifactType);
    (0, common_1.finleyAssert)(converter, `no converter found for artifactType: ${artifactType}`);
    return converter;
};
exports.getConverterByArtifactType = getConverterByArtifactType;
const getConverterByNodeType = (nodeType) => {
    const converter = tapeConvertorArray.find((con) => con.nodeType === nodeType);
    (0, common_1.finleyAssert)(converter, `no converter found for nodeType: ${nodeType}`);
    return converter;
};
const detachOperationNodes = ({ graph, artifactDocumentId, }) => {
    const dataTapes = [];
    const dataTapeDependencies = [];
    const nodeMap = new Map();
    let updatedEdges = [...graph.edges];
    graph.nodes.forEach((destNode) => {
        const uiNode = (0, uiNodes_1.getUINodeByType)(destNode.metadata.tapeBuilderNodeType);
        if (!uiNode.isOperation) {
            // we ignore operation nodes, as they are not stored in the database.
            // we include operations as part of destination nodes in Db.
            const convertor = getConverterByNodeType(destNode.metadata.tapeBuilderNodeType);
            const { record, operationNode } = convertor.uiNodesToIntermediate({
                artifactDocumentId,
                graph,
                node: destNode,
            });
            dataTapes.push(record);
            if (operationNode) {
                // remove link between operation node and destination node
                // since that link is not needed in the dbGraph
                updatedEdges = updatedEdges.filter(({ source, target }) => {
                    const filterOut = source === operationNode.metadata.tapeBuilderNodeId &&
                        target === destNode.metadata.tapeBuilderNodeId;
                    return !filterOut;
                });
                // map operation node to destination node
                nodeMap.set(operationNode.metadata.tapeBuilderNodeId, destNode.metadata.tapeBuilderNodeId);
            }
            else {
                // there is no operation node, so destination node id stays the same
                nodeMap.set(destNode.metadata.tapeBuilderNodeId, destNode.metadata.tapeBuilderNodeId);
            }
        }
    });
    // fixup edges
    updatedEdges.forEach((edge) => {
        const { source, target } = edge;
        const sourceTapeBuilderNodeId = source;
        const targetTapeBuilderNodeId = nodeMap.get(target);
        (0, common_1.finleyAssert)(sourceTapeBuilderNodeId !== undefined, `sourceTapeBuilderNodeId is undefined for source ${source}`);
        (0, common_1.finleyAssert)(targetTapeBuilderNodeId !== undefined, `targetTapeBuilderNodeId is undefined for target ${target}`);
        dataTapeDependencies.push({
            inputArtifactId: sourceTapeBuilderNodeId,
            outputArtifactId: targetTapeBuilderNodeId,
        });
        // propagate the credit facility id and loan product id
        // to the generated tapes (if they don't already have them)
        const destNode = dataTapes.find((tape) => {
            return tape.id === targetTapeBuilderNodeId;
        });
        (0, common_1.finleyAssert)(destNode, `destNode is undefined: ${targetTapeBuilderNodeId}`);
        const srcNode = dataTapes.find((tape) => {
            return tape.id === sourceTapeBuilderNodeId;
        });
        (0, common_1.finleyAssert)(srcNode, `srcNode is undefined: ${sourceTapeBuilderNodeId}`);
    });
    return {
        dataTapes,
        dataTapeDependencies,
    };
};
exports.detachOperationNodes = detachOperationNodes;
//# sourceMappingURL=converters.js.map